// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show-mobile {
  display: none;
  visibility: hidden;
}
/* admin shell: white sidebar, gray main area */
.sidebar {
  background: #ffffff;
}
@media (max-width: 600px) {
  .sidebar {
    display: none;
  }
  .sidebar-small {
    display: none;
  }
  .navbar-top {
    box-shadow: none !important;
    border-bottom: 0px !important;
  }
  .sidebar.open {
    width: 0px;
  }
  .hidden-mobile {
    display: none;
    visibility: hidden;
  }
  .show-mobile {
    display: inline;
    visibility: visible;
  }
  .navbar-top .user-menu {
    list-style: none;
    float: right;
    margin-right: 20px;
    margin-top: 5px;
  }
}
/*# sourceMappingURL=admin.component.css.map */`, "",{"version":3,"sources":["webpack://./admin.component.less","webpack://./src/app/layout/admin.component.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kBAAA;ACDF;AACA,+CAA+C;ADI/C;EAAW,mBAAA;ACDX;ADGA;EACA;IACA,aAAA;ECDE;EDIF;IAEI,aAAA;ECHF;EDOF;IACI,2BAAA;IACA,6BAAA;ECLF;EDQF;IACI,UAAA;ECNF;EDSF;IACI,aAAA;IACA,kBAAA;ECPF;EDUF;IACI,eAAA;IACA,mBAAA;ECRF;EDWF;IACI,gBAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;ECTF;AACF;AACA,8CAA8C","sourcesContent":["@import (reference) \"../../assets/less/colors.less\";\n\n.show-mobile {\n  display: none;\n  visibility: hidden;\n}\n\n/* admin shell: white sidebar, gray main area */\n.sidebar { background: @white; }\n\n@media (max-width: 600px) {\n.sidebar {\ndisplay: none;\n}\n\n.sidebar-small {\n\n    display: none;\n\n}\n\n.navbar-top {\n    box-shadow: none !important;\n    border-bottom: 0px !important;\n}\n\n.sidebar.open {\n    width: 0px;\n}\n\n.hidden-mobile {\n    display: none;\n    visibility: hidden;\n}\n\n.show-mobile {\n    display: inline;\n    visibility: visible;\n}\n\n.navbar-top .user-menu {\n    list-style: none;\n    float: right;\n    margin-right: 20px;\n    margin-top: 5px;\n}\n}\n\n",".show-mobile {\n  display: none;\n  visibility: hidden;\n}\n/* admin shell: white sidebar, gray main area */\n.sidebar {\n  background: #ffffff;\n}\n@media (max-width: 600px) {\n  .sidebar {\n    display: none;\n  }\n  .sidebar-small {\n    display: none;\n  }\n  .navbar-top {\n    box-shadow: none !important;\n    border-bottom: 0px !important;\n  }\n  .sidebar.open {\n    width: 0px;\n  }\n  .hidden-mobile {\n    display: none;\n    visibility: hidden;\n  }\n  .show-mobile {\n    display: inline;\n    visibility: visible;\n  }\n  .navbar-top .user-menu {\n    list-style: none;\n    float: right;\n    margin-right: 20px;\n    margin-top: 5px;\n  }\n}\n/*# sourceMappingURL=admin.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
